import LazyLoad from './lazyLoad';
import Accordion from './accordion';

const $ = jQuery.noConflict();

'use strict';
const SearchDropdownFacilities = {
	/*-------------------------------------------------------------------------------
        # Cache dom and strings
    -------------------------------------------------------------------------------*/

	$wrapper: $('.search-result-box'),


	/*-------------------------------------------------------------------------------
        # Initialize
    -------------------------------------------------------------------------------*/
	init: function() {

		this.search();
		this.loadingQuote();

	},

	search: function() {
		$('.js-option-search').click(() => {
			if ((location.pathname === '/') || (location.pathname === '/about/') || (location.pathname === '/careers/')) {
				window.location.href = window.location.href + '/search-result/';
				const services = [];
				$.each($('.select-check-box :selected'), function() {
					services.push($(this).text());
				});
				if (services) {
					localStorage.setItem('services', JSON.stringify(services));
				}
			}
			const services = [];
			$.each($('.select-check-box :selected'), function() {
				services.push($(this).text());
			});
			this.ajax(services);
		});
	},

	loadingQuote: function() {
		$(() => {
			const local = JSON.parse(localStorage.getItem('services'));
			if (local) {
				local.forEach((loc) => {
					$('.select2-search select2-search--inline').remove();
					$('.select2-search__field').remove();
					const li = $('<li class="select2-selection__choice" data-select2-id="">').text(loc);
					const span = $('<span class="select2-selection__choice__remove" role="presentation">').text('×');
					const li2 = $('<li class="select2-search select2-search--inline">');
					const input = $('<input class="select2-search__field" type="search" tabindex="0" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" placeholder="" style="width: 0.75em;">');
					$('.select2-selection__rendered').append(li.append(span)).append(li2.append(input));

					$('input:text').focus();
					$.each($('.select-check-box option'), function() {
						if(loc === $(this).text()){
							$(this).prop('selected', 'selected');
						}
					});
					$(span).click(() => {
						$(li).remove();
						$.each($('.select-check-box option'), function() {
							if(loc === $(this).text()){
								$(this).prop('selected', false);
							}
						});
					});
				});
				this.ajax(local);
				localStorage.removeItem('services');
			}
		}
		);
	},

	ajax: function(services) {
		$.ajax({
			type: 'POST',
			// eslint-disable-next-line no-undef,camelcase
			url: citadel_corp_ajax.ajax_url,
			data: {
				action: 'searchServices',
				services: services
			},
			success: function(response) {
				$('.search-result-box').empty();
				$('.search-block__boxes-info').empty();
				$(response.htmlPosts).appendTo($('.search-result-box'));
				if (response.count > 0) {
					$('.search-block__boxes-info').append(response.count + ' Search Results').show();
				} else {
					$('.search-block__boxes-info').append('No Search Results').show();
				}
				$('.js-search-block-icon').each(function(e, el) {
					$(el).on('click', function() {
						const _self = $(this);
						if (_self.parent().hasClass('is-active')) {
							_self.parent().removeClass('is-active');
							_self.siblings('.js-search-block-hidden').slideUp();
						} else {
							_self.parent().addClass('is-active');
							_self.siblings('.js-search-block-hidden').slideDown();
							_self.parent().siblings().removeClass(Accordion.classActive).find('.js-search-block-hidden').slideUp();
						}
					});
				});
				LazyLoad.init();
			},
		});
	}
};

export default SearchDropdownFacilities;
